import React, { useEffect, useState } from 'react';
import axios from 'axios';
import style from './AgentSessionDetail.module.css';
import { useParams, Link } from 'react-router-dom';

const formatTime = (ms) => {
  if (!ms) return '-';
  const totalSeconds = Math.floor(Number(ms) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
};

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleString();
};

const AgentSessionDetail = () => {
  const { id } = useParams();
  const [agent, setAgent] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [totalSessions, setTotalSessions] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgentDetail = async () => {
      try {
        const res = await axios.get(`/session-history?userId=${id}`);
        setAgent(res.data.agent);
        setSessions(Array.isArray(res.data.sessions) ? res.data.sessions : []);
        setTotalSessions(res.data.totalSessions || 0);
      } catch (error) {
        console.error('Error al obtener el detalle del agente:', error);
        setSessions([]);
      } finally {
        setLoading(false);
      }
    };
    fetchAgentDetail();
  }, [id]);

  // Calcular tiempo acumulado y promedio de uso por sesión
  const validSessions = sessions.filter(s => s.durationMs && !isNaN(Number(s.durationMs)));
  const totalMs = validSessions.reduce((acc, s) => acc + Number(s.durationMs), 0);
  const avgMs = validSessions.length ? totalMs / validSessions.length : 0;

  return (
    <div className={style.detailContainer}>
      <Link to="/dashboard-sesiones" className={style.backLink}>← Volver al Dashboard</Link>
      {loading ? (
        <p className={style.loading}>Cargando...</p>
      ) : agent ? (
        <div className={style.agentCard}>
          <img src={agent.photo} alt={agent.name} className={style.avatar} />
          <div className={style.agentInfo}>
            <h2>{agent.name} {agent.last_name}</h2>
            <p><strong>ID:</strong> {agent.id}</p>
            <p><strong>Email:</strong> {agent.mail}</p>
            <p><strong>Tipo:</strong> {agent.type}</p>
            <p><strong>Rango:</strong> {agent.rank}</p>
            <p><strong>Sesiones totales:</strong> {totalSessions}</p>
            <p><strong>Tiempo acumulado:</strong> {formatTime(totalMs)}</p>
            <p><strong>Promedio por sesión:</strong> {formatTime(avgMs)}</p>
          </div>
        </div>
      ) : (
        <p className={style.error}>Agente no encontrado.</p>
      )}

      <h3 className={style.sessionsTitle}>Historial de Sesiones</h3>
      <div className={style.sessionsTableWrapper}>
        <table className={style.sessionsTable}>
          <thead>
            <tr>
              <th>#</th>
              <th>Inicio</th>
              <th>Fin</th>
              <th>Duración</th>
            </tr>
          </thead>
          <tbody>
            {(sessions || []).map((session, idx) => (
              <tr key={session.id || idx}>
                <td>{idx + 1}</td>
                <td>{formatDate(session.startTime)}</td>
                <td>{session.endTime ? formatDate(session.endTime) : '-'}</td>
                <td>{session.durationMs ? formatTime(session.durationMs) : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentSessionDetail;